import { Component, Input, OnInit } from '@angular/core';
import { JobBoardService } from '../../../../../../shared/services/job-board.service';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { PipesModule } from '../../../../../../shared/pipes/pipes.module';
import { UserClientVm } from '../../../../../../store/user/user.interface';
import { UserService } from '../../../../../../shared/services/user.service';
import { RatingModule } from 'primeng/rating';
import { FormsModule } from '@angular/forms';
import { ConfirmationDialogService } from '../../../../../../shared/services/confirmation-dialog.service';
import { ReviewerDetailDialogService } from '../../../../../../shared/services/reviewer-detail-dialog.service';
import { HelperService } from '../../../../../../shared/services/helper.service';

@Component({
  selector: 'app-candidates-tab',
  standalone: true,
  imports: [
    TableModule,
    ButtonModule,
    CommonModule,
    TooltipModule,
    PipesModule,
    RatingModule,
    FormsModule,
  ],
  templateUrl: './candidates-tab.component.html',
  styleUrl: './candidates-tab.component.scss'
})
export class CandidatesTabComponent implements OnInit {
  @Input() jobId: string | null = null;
  searchText: string = '';
  candidates: any[] = [];
  candidatesCount: number = 0;
  user!: UserClientVm;

  constructor(
    private jobBoardService: JobBoardService,
    private userService: UserService,
    public helperService: HelperService,
    private confirmationDialogService: ConfirmationDialogService,
    private reviewerDetailDialogService: ReviewerDetailDialogService
  ) { }

  ngOnInit(): void {
    this.user = this.userService.getSessionUser();
  }

  async getCandidates(event?: any): Promise<void> {
    const res = await this.jobBoardService.getAllApplicants({
      jobId: this.jobId,
      limit: 10,
      offset: event?.first ? event?.first : 0,
      search: this.searchText,
      searchOn: 'all',
      noCache: true
    });
    
    this.candidatesCount = res[res.length - 1]?.totalCount?? 0;
    this.candidates = res.slice(0, -1);
    this.candidates = this.candidates.map((user: any) => {
      return {
        ...user,
        defaultTenantRating: user.appliedCandidateId.tenants && user.appliedCandidateId.tenants.length > 0 && user.appliedCandidateId.tenants[0].defaultRatings
      }
    });
  }

  async onShortlistCandidate($event: Event, candidate: any): Promise<void> {
    $event.stopPropagation();
    try {
      await this.jobBoardService.updateCandidate({_id: candidate._id, selectedField: 'favourite', selectedValue: !candidate.favourite});
      candidate.favourite = !candidate.favourite;
    } catch (err) {
      console.error('Error shortlisting candidate:', err);
    }
  }

  async onMarkNotInterested($event: Event, candidate: any): Promise<void> {
    $event.stopPropagation();
    this.confirmationDialogService.confirm({
      message: 'Are you sure you are not interested in this candidate? This candidate will be removed from your candidate list.',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: "none",
      rejectIcon: "none",
      rejectButtonStyleClass: "p-button-text",
      accept: async () => {
        await this.jobBoardService.updateCandidate({_id: candidate._id, selectedField: 'notInterested', selectedValue: !candidate.notInterested});
        await this.getCandidates();
      }
    });
    
  }

  openReviewerDialog(id:string){
    this.reviewerDetailDialogService.openDialog(id);
  }
}
